import baseV3Service from './base/baseV3Service.js';

const getDxSettings = (config) => {
    return baseV3Service.get(`dx-settings`, config);
};
const createDxSettings = (service, payload, config) => {
    return baseV3Service.post(`dx-settings/${service}`, payload, config);
};
const updateDxSettings = (service, dxSettingsId, payload, config) => {
    return baseV3Service.put(`dx-settings/${service}/${dxSettingsId}`, payload, config);
};
const getDxSettingsServicesFields = (service, config) => {
    return baseV3Service.get(`dx-settings/${service}/fields`, config);
};
const testDxSettingsPMSIntergration = (service, payload, config) => {
    return baseV3Service.post(`dx-settings/${service}/test-pms-integration`, payload, Object.assign(Object.assign({}, config), { params: {} }));
};

export { createDxSettings, getDxSettings, getDxSettingsServicesFields, testDxSettingsPMSIntergration, updateDxSettings };
